<template>
    <h2 class="heading">Company Document Form</h2>
    <div class="form">
        <el-form :model="companyDoc" label-width="350px" style="width:900px" >
            <el-form-item label="Document title" required>
                <el-input v-model="companyDoc.documentTitle" placeholder="Document title" maxlength="200"  show-word-limit="true" />
            </el-form-item>
            <el-form-item label="Document files">
                <div v-if="files.indexOf(':') > -1" style="display:block;">
                    <template v-for="item in files.split(';')" :key="item">
                        <el-tag v-if="item.length" @close="removeFile(item)" closable>
                            <a @click="global.down(item.split(':')[1], item.split(':')[0])">{{item.split(':')[0]}}</a>
                        </el-tag>
                    </template>
                </div>
                <el-upload :action="global.upload_path" multiple :on-success="uploaded" :data="{type:'companyDoc'}" :show-file-list="false" >
                    <el-button type="primary" plain>Browse</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label="Completed before date" required>
                <el-date-picker v-model="companyDoc.deadline" type="date" placeholder="Completed before date" value-format="YYYY-MM-DD"/>
            </el-form-item>
            <el-form-item label="Note to approver">
                <el-input v-model="companyDoc.noteToApprover" type="textarea" maxlength="200" show-word-limit="true"/>
            </el-form-item>
            
            <el-form-item label="Department endorsement">
                <el-select v-model="dept" placeholder="Select departments" style="width:220px;margin-right:10px;" @change="selectDept">
                    <el-option v-for="dept in allDepts" :key="dept" :label="dept"  :value="dept"/>
                </el-select>
                <template v-if="companyDoc.departments && companyDoc.departments.length">
                    <el-tag v-for="dept in companyDoc.departments.split(',')" :key="dept" @close="removeTag(dept)" closable>{{dept}}</el-tag>
                </template>
            </el-form-item>
            <el-form-item label="Final approver">
                <el-select v-model="companyDoc.approver" placeholder="Select final approver" style="width:220px;">
                    <el-option label="Josephine Tang" value="Josephine Tang"/>
                    <el-option label="Rebecca Chua" value="Rebecca Chua"/>
                </el-select>
            </el-form-item>

            <el-form-item label="">
                <el-button type="primary" @click="submitDocument" style="margin-right:10px;">Submit</el-button>
                <el-button @click="$router.push('/companyDoc/allCompanyDocs')">Cancel</el-button>
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
                <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                    <img src="@/assets/loading.gif" style="height:24px;"/>
                </span>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
const allDepts = ["Admin", "Clients", "Compliance", "Investment", "IT", "Operations", 
                  "Product", "Partners", "Research", "Trading"];
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            allDepts, 
            dept : '',
            companyDoc: {
                id: null,
                documentTitle: '',
                departments: '',
                files: '',
                deadline: '',
                approver: '',
                noteToApprover: '',
                createTime: null,
                lastupdate: null,
                signOffList: null,
            },
            loading: false,
            files: '',
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "companyDoc";
        let code = this.$route.query ? this.$route.query.code : null;
        if (code) {
            let result = await AXIOS("/companyDoc/getCompanyDoc", {code: code});
            if (result.success) {
                this.companyDoc = result.data;
                if (this.companyDoc.files.indexOf(":")>-1)
                    this.files = this.companyDoc.files;
            } else {
                this.errMsg = result.errMsg;
            }
        }
    },
    methods: {
        uploaded(response) {
            let files = response.length ? response[0].name + ":" + response[0].url : '';
            if (files != '' && this.files.indexOf(files) == -1) {
                this.files = (this.files == '') ? files : this.files + ";" + files;
            }
        },
        removeFile(item) {
            this.files = this.files + ";"
            this.files = this.files.replace(item+";", "");
            if (this.files.endsWith(";"))
                this.files = this.files.substring(0, this.files.length-1);
        },
        selectDept() {
            if (this.companyDoc.departments.indexOf(this.dept) == -1) {
                this.companyDoc.departments = (this.companyDoc.departments == '') ? this.dept : 
                    this.companyDoc.departments + "," + this.dept;
            }
        },
        removeTag(dept) {
            let depts = (this.companyDoc.departments + ",").replace(dept+",", "")
            this.companyDoc.departments = (depts.length > 0) ? depts.substring(0, depts.length-1) : "";
        },
        async submitDocument() {
            this.errMsg = "";
            if (this.companyDoc.documentTitle == "") {
                this.errMsg = "[Document title] is required"; return;
            }
            if (this.files == "") {
                this.errMsg = "[Document files] is required"; return;
            }
            if (this.companyDoc.deadline == "") {
                this.errMsg = "[Completed before date] is required"; return;
            }
            if (this.companyDoc.departments == "") {
                this.errMsg = "[Department Endorsement] is required"; return;
            }
            if (this.companyDoc.approver == "") {
                this.errMsg = "[Final approver] is required"; return;
            }
            this.companyDoc.files = this.files;
            this.companyDoc.createTime = null;
            this.companyDoc.lastupdate = null;
            this.companyDoc.signOffList = [];
            if (this.loading) return;
            this.loading = true;

            let result = await AXIOS("/companyDoc/saveCompanyDoc", this.companyDoc);
            if (result.success) {
                this.$router.push("/companyDoc/allCompanyDocs");
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .heading {
        width:900px;
    }
    .errMsg {
        padding-left:10px;
    }
    .el-tag a {cursor:pointer;}
    .el-form-item__content {padding-left: 8px; border-bottom:0;}
</style>